export const DEFAULT_BASE_URL = '/forms/boxforms';

export const BASE_API_URL = '/app-api/file-request-web';
export const CURRENT_USER_API_URL = '/app-api/enduserapp/current-user';
export const SEARCH_ITEM_API_URL = '/app-api/enduserapp/quick-search';
export const METADATA_API_URL =
  '/app-api/end-user-web/metadata-templates?scope=enterprise&limit=1000';
export const FILE_REQUEST_REST_API_URL = `${BASE_API_URL}/file-request`;
export const FILE_REQUEST_DASHBOARD_REST_API_URL = `${BASE_API_URL}/file-request-dashboard`;
export const FILE_REQUEST_REST_API_BULK_URL = `${BASE_API_URL}/file-requests`;
export const LEGACY_FILE_REQUEST_REST_API_BULK_URL = `${BASE_API_URL}/legacy-file-requests`;
export const LEGACY_FILE_REQUEST_REST_API_URL = `${BASE_API_URL}/legacy-file-request`;
export const LEGACY_FILE_REQUEST_DASHBOARD_REST_API_URL = `${BASE_API_URL}/legacy-file-request-dashboard`;
export const FILE_REQUEST_REST_PUBLIC_API_URL = `${BASE_API_URL}/public/file-request`;
export const FORM_VERSION_REST_API_URL = `${BASE_API_URL}/form-version`;
export const FORM_RESPONSE_REST_API_URL = `${BASE_API_URL}/form-response`;
export const FORM_RESPONSE_REST_PUBLIC_API_URL = `${BASE_API_URL}/public/form-response`;
export const FORM_BRANDING_REST_API_URL = `${BASE_API_URL}/branding`;
export const FORM_REST_API_URL = `${BASE_API_URL}/form`;

export const FILE_REQUEST_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
};

export const MODE = {
  FILE_REQUEST: 'file_request',
  FORM: 'form',
};

export const FRIENDLY_FILE_REQUEST_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DELETED: 'Deleted',
};

export const FILE_REQUEST_VISIBILITY = {
  AUTHENTICATED: 'AUTHENTICATED',
  OPEN: 'OPEN',
};

export const FRIENDLY_FILE_REQUEST_VISIBILITY = {
  AUTHENTICATED: 'Private',
  OPEN: 'Public',
};

export const FORM_RESPONSE_STATUS = {
  COMPLETE: 'COMPLETE',
};

export const DATE_RANGE_KEYS = {
  CREATED_AT: 'createdAt',
  MODIFIED_AT: 'modifiedAt',
};

export const CUSTOM_RANGE_KEYS = {
  START: 'start',
  END: 'end',
};

export const DASHBOARD_ACTION_TYPES = {
  ACTIVATE: 'activate',
  DELETE: 'delete',
  DEACTIVATE: 'deactivate',
};

export const DATE_RANGE_SELECTIONS = {
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
  CUSTOM: 'custom',
  NONE: 'none',
};

export const DAY_MILLISECONDS = 24 * 60 * 60 * 1000;

export const FILE_REQUEST_FAQ_URL =
  'https://support.box.com/hc/en-us/articles/360045304813-Using-File-Request-to-get-Content-from-Anyone';
export const METADATA_FAQ_URL =
  'https://community.box.com/t5/Organizing-and-Tracking-Content/Using-Metadata/ta-p/30765';
export const BOX_TERMS_OF_SERVICE_URL =
  'https://www.box.com/legal/termsofservice';
export const BOX_PRIVACY_NOTICE_URL = 'https://www.box.com/legal/privacypolicy';
export const FORM_FIELD_FAQ_URL = ''; // TODO: Add url when available (FORMS-4557)
export const CLASSIFICATION_TEMPLATE_KEY_PREFIX = 'securityClassification-';
export const AUTO_CLASSIFICATION_TEMPLATE_KEY =
  'autoClassificationResults-4gbDxrvfKGZn';

export const ELEMENT_ID_PREFIX = 'element-';

export const ELEMENT_DESCRIPTION_ID = 'element-description-required';
export const ELEMENT_EMAIL_ID = 'element-email-required';

// These types are stored on the backend via form content
export const TYPE_GROUP = 'group';
export const TYPE_DATE_FIELD = 'dateField';
export const TYPE_NUMBER_FIELD = 'numberField';
export const TYPE_RADIO_FIELD = 'radioField';
export const TYPE_CHECKBOX_FIELD = 'checkboxField';
export const TYPE_SELECT_FIELD = 'selectField';
export const TYPE_STATIC_TEXT_FIELD = 'staticTextField';
export const TYPE_TEXT_FIELD = 'textField';
export const TYPE_UPLOAD_FIELD = 'uploadField';
export const TYPE_DROPDOWN_FIELD = 'dropdownField';

export const FieldTypes = {
  TYPE_GROUP,
  TYPE_DATE_FIELD,
  TYPE_NUMBER_FIELD,
  TYPE_CHECKBOX_FIELD,
  TYPE_RADIO_FIELD,
  TYPE_SELECT_FIELD,
  TYPE_STATIC_TEXT_FIELD,
  TYPE_TEXT_FIELD,
  TYPE_UPLOAD_FIELD,
  TYPE_DROPDOWN_FIELD,
};

// TEXT TYPES
export const TEXTTYPE_TEXT = 'text';
export const TEXTTYPE_EMAIL = 'email';
export const TEXTTYPE_NUMBER = 'number';

// These types only exist in UI and are used to distinguish fields in the DnD/Add Field Menu
// This is because certain field types (text, long text, etc.)
// would have the same underlying type in form content, but need to be differentiated
// in the menu
export const MENU_TYPE_SHORT_TEXT_FIELD = 'text-field';
export const MENU_TYPE_LONG_TEXT_FIELD = 'long-text-field';
export const MENU_TYPE_CHECKBOX_FIELD = 'checkbox-field';
export const MENU_TYPE_RADIO_FIELD = 'radio-field';
export const MENU_TYPE_SELECT_FIELD = 'select-field';
export const MENU_TYPE_NUMBER_FIELD = 'number-field';
export const MENU_TYPE_DATE_TIME_FIELD = 'date-field';
export const MENU_TYPE_STATIC_TEXT_FIELD = 'static-text-field';
export const MENU_TYPE_FILE_UPLOAD_FIELD = 'upload-field';
export const MENU_TYPE_FILE_METADATA_FIELD = 'file-metadata-field';
export const MENU_TYPE_ADDRESS_FIELD = 'address-field';
export const MENU_TYPE_NAME_FIELD = 'name-field';
export const MENU_TYPE_PHONE_FIELD = 'phone-field';
export const MENU_TYPE_EMAIL_FIELD = 'email-field';
export const MENU_TYPE_DESCRIPTION_FIELD = 'description-field';

export const METADATA_NUMBER_FIELD_TYPE = 'float';
export const METADATA_STRING_FIELD_TYPE = 'string';
export const METADATA_DATE_FIELD_TYPE = 'date';
export const METADATA_SELECTION_FIELD_TYPE = 'multiSelect';
export const METADATA_ENUM_FILED_TYPE = 'enum';

export const METADATA_FIELD_KEY = 'metadataFieldKey';
export const METADATA_TEMPLATE_ID = 'metadataTemplateId';

export const FORMS_MENU_FIELDS = [
  // TODO: re-enable these as they are implemented
  MENU_TYPE_SHORT_TEXT_FIELD,
  MENU_TYPE_LONG_TEXT_FIELD,
  // MENU_TYPE_SELECT_FIELD,
  // MENU_TYPE_NUMBER_FIELD,
  // MENU_TYPE_DATE_TIME_FIELD,
  // MENU_TYPE_STATIC_TEXT_FIELD,
  MENU_TYPE_CHECKBOX_FIELD,
  MENU_TYPE_RADIO_FIELD,
  MENU_TYPE_FILE_UPLOAD_FIELD,
  MENU_TYPE_FILE_METADATA_FIELD,
];
export const FORMS_PREDEFINED_FIELDS = [
  // TODO: also re-enable these as they are implemented
  // MENU_TYPE_ADDRESS_FIELD,
  // MENU_TYPE_NAME_FIELD,
  // MENU_TYPE_PHONE_FIELD,
  // MENU_TYPE_EMAIL_FIELD,
];

export const FILE_REQUEST_MENU_FIELDS = [
  MENU_TYPE_DESCRIPTION_FIELD,
  MENU_TYPE_EMAIL_FIELD,
  MENU_TYPE_FILE_UPLOAD_FIELD,
  MENU_TYPE_FILE_METADATA_FIELD,
];
export const FILE_REQUEST_PREDEFINED_FIELDS = [];

export const FILES = 'files';

export const GROUP_LABEL_LIMIT = 100;
export const GROUP_DESCRIPTION_LIMIT = 1000;
export const FIELD_LABEL_LIMIT = 100;
export const FIELD_DESCRIPTION_LIMIT = 200;

export const EMAIL_FIELD_LIMIT = 255;
export const FILE_DESCRIPTION_FIELD_LIMIT = 255;
export const LONG_TEXT_FIELD_LIMIT = 1000;

// Fields need room for options/handle
// TODO: Figure out a less hacky way to make this work
export const FIELD_LABEL_EDIT_WIDTH = '90%';
export const GROUP_LABEL_EDIT_WIDTH = '100%';

export const DEFAULT_EMPTY_FILE_REQUEST = {
  allowDescription: false,
  folder: { type: 'FOLDERS', id: '' },
  id: '',
  modifiedAt: '',
  modifiedBy: {
    id: '',
    type: '',
  },
  submitterEmailRequired: false,
  status: FILE_REQUEST_STATUS.INACTIVE,
  url: '',
  urlId: '',
  visibility: '',
  form: {
    content: {
      components: {
        'group-0': {
          id: 'group-0',
          type: TYPE_GROUP,
          items: [],
        },
      },
    },
  },
};

export const EMPTY_FR_FOR_FORMS = {
  type: 'form',
  status: 'ACTIVE',
  visibility: 'OPEN',
  modifiedBy: {
    id: '',
    type: '',
  },
  form: {
    content: {
      root: 'group-0',
      layouts: {
        'group-0': {
          paginated: false,
        },
      },
      components: {
        'group-0': {
          id: 'group-0',
          type: 'group',
          label: '',
          description: '',
          items: [],
        },
      },
    },
  },
};

export const DISPLAY_FORMAT = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export const KEYBOARD_CODE = {
  ENTER: 13,
  ESC: 27,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
};

export const STATUS_CODE = {
  NOT_FOUND: 404,
};

export const FORM_PATH = 'workingFileRequest.form';
export const CONTENT_PATH = 'content';
export const FORM_CONTENT_PATH = `${FORM_PATH}.${CONTENT_PATH}`;
export const METADATA_TEMPLATE_ID_PATH = `${FORM_PATH}.metadataTemplateId`;

export const FOLDER_URL = '/folder/';
export const FILE_REQUEST_DASHBOARD_URL = '/master/fileRequestDashboard';
export const LEGACY_FILE_REQUEST_DASHBOARD_URL =
  '/master/fileRequestDashboard/classic';

export const MAX_FILES_PER_SUBMISSION = 500;
export const MAX_FILE_SIZE = 34359738367;
export const MAX_FILE_SIZE_TEXT = '32 GB';

export const NUM_LOADING_ROWS = 20;
export const CONTENT_PICKER_PAGE_SIZE = 50;
export const HOMEPAGE_FOLDER_ID = '0';

export const REGEX_EMAIL_VALIDATION = /^(([^_\-<>()[\]\\.,;:\s@"][^<>()[\]\\.,;:\s@"]*(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EMAIL_ELEMENT = 'element-email-required';

// filename validation pattern found here: https://git.dev.box.net/Box/scm/blob/v5-dev/modular/files-page/item-list/legacy/helpers/Item.php#L144
// eslint-disable-next-line no-control-regex
export const REGEX_FILE_NAME_VALIDATION = /[\x00-\x1f\x7f/\\\\\u{fffe}-\u{10ffff}]/u;

// Simplified version of REGEX_FILE_NAME_VALIDATION
// DB only supports standard utf8, which covers Unicode BMP
// Unicode BMP covers U+0000 - U+FFFF
// This regex checks for:
// - non-characters from Unicode Plane 1 (U+FFFE and U+FFFF)
// - Unicode Planes 2-16 (U+10000 through U+10FFFF)
export const REGEX_UNICODE_BMP_VALIDATION = /[\u{fffe}-\u{10ffff}]/u;

export const ACCEPTED_IMG_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
export const MAX_CUSTOM_LOGO_SIZE = 1048576;

export const PALETTE_COLORS = [
  '222222',
  '767676',
  '8e44ad',
  'c0392b',
  'e74c3c',
  'd35400',
  'e67e22',
  'f39c12',
  '16a085',
  '27ae60',
  '1abc9c',
  '2980b9',
  '3498db',
];

export const REGEX_COLOR_VALIDATION = /^#?[0-9A-Fa-f]{6}$/;

// Performance Logging constants
export const APDEX_THRESHOLD_MS = 3000;
export const OPEN_FILE_REQUEST_MODAL = 'open_file_request_modal';
export const FILE_REQUEST_MENU_CLICK = 'file_request_menu_click';
export const FILE_REQUEST_MODAL_LOAD = 'file_request_modal_load';

// Ongoing SPLIT.IO Treatments
// Do NOT put prefixes "user_" & "enterprise_" within your split names
export const COREY_SPLIT_TEST = 'workflow_cghilarducci_testing';
export const NEW_BUILDER_FOR_FILE_REQUEST =
  'forms_file_request_with_the_new_forms_builder_experience_q1fy24';

// Batch size of file ids for updateFileIds calls
export const PATCH_FILE_ID_BATCH_SIZE = 10;

// keyboard events
export const KEYS = {
  escape: 'Escape',
};

export const CURSOR_OFFSET_X = 50;
export const CURSOR_OFFSET_Y = 50;
export const INSERT_DIVIDER_HEIGHT = 6;
export const BOTTOM_DISPLACEMENT_THRESHOLD = 200;
export const TOP_DISPLACEMENT_THRESHOLD = 200;
export const SCROLL_INCREMENT = 1;
export const DISPLAY_BOUND_WIDTH = 15;

export const MODE_FEATURES = {
  NEW_THEME_HEADER: 'new-theme-header',
  SUBMISSION_MENU: 'submissionMenu',
  RICH_TEXT_EDITOR: 'richTextEditor',
  // toolbar features
  TWO_COLUMN_LAYOUT: 'twoColumnLayout',
  DUP_FIELD: 'duplicateField',
  FIELD_SETTINGS: 'fieldSettings',
  // add fields menu
  SHORT_TEXT: 'text-field',
  LONG_TEXT: 'long-text-field',
  CHECKBOX: 'checkbox-field',
  RADIO: 'radio-field',
  SELECT: 'select-field',
  NUMBER: 'number-field',
  DATE_TIME: 'date-field',
  STATIC_TEXT: 'static-text-field',
  PREDEFINED_FIELDS_SUBMENU: 'predefinedFieldsSubmenu',
  EMPTY_STATE: 'emptyState',
  LOGIC_BUILDER: 'logicBuilder',
};

export const SUBMISSION_LIST_LIMIT = 20;
export const FORM_FIELDS_LIMIT = 4;
export const NUM_ROWS_LOADING_STATE = 7;
export const DEFAULT_MAX_SELECTIONS = 1;
